"use client";
import { useMemo } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { Card, CardHeader } from "@/components/headToHead/Card";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import { SCREENS } from "@/constants/breakpoints";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import {
  PlayerStatsContextProvider,
  usePlayerStatsContext,
} from "@/utils/hooks/useHeadToHeadPlayerStatsContext";
import useMedia from "@/utils/hooks/useMedia";
import Table from "../../Table";
import { TABLE_COLUMN_DEFINITIONS_MAP } from "./columnDefs";
import PositionSelector from "./PositionSelector";
import usePlayerStatistics from "./usePlayerStatistics";
import { statsArePreviousSeasonYear } from "./util";
import styles from "./playerStatsTable.module.scss";

function Content() {
  const { players, isLoading, isError, refetch } = usePlayerStatistics();
  const { position, toPosition } = usePlayerStatsContext();

  const filteredPlayers = useMemo(
    () => players.filter(toPosition),
    [players, toPosition]
  );

  const hasData = filteredPlayers.length > 0;

  const columnDefs = TABLE_COLUMN_DEFINITIONS_MAP[position];

  if (isError && !hasData && !isLoading) {
    return (
      <ErrorComponent
        ctaButtonLabel="Retry"
        ctaButtonOnClick={async () => refetch()}
      />
    );
  } else if (isLoading) {
    return <LoadingBackdrop loading />;
  }

  return <Table data={filteredPlayers} columns={columnDefs} />;
}

export default function PlayerStatsTable() {
  const { seasonYear } = useHeadToHeadContext();
  const { weekOneEnd, players } = usePlayerStatistics();
  const isMobile = useMedia(`(max-width: ${SCREENS.SM})`);
  let displayYear = seasonYear;
  if (statsArePreviousSeasonYear(weekOneEnd, players)) {
    displayYear--;
  }
  return (
    <Card className={styles.card}>
      <CardHeader title={`${displayYear} Player Stats`} />
      <PlayerStatsContextProvider>
        <div className={styles.content}>
          <PositionSelector isMobile={isMobile} />
          <Content />
        </div>
      </PlayerStatsContextProvider>
    </Card>
  );
}
